import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';


const TransactionFilters = ({ onFiltersChange, onClearFilters }) => {
  const [filters, setFilters] = useState({
    search: '',
    dateFrom: '',
    dateTo: '',
    status: '',
    recipient: '',
    currency: '',
    amountMin: '',
    amountMax: ''
  });

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'pending', label: 'Pending' },
    { value: 'processing', label: 'Processing' },
    { value: 'compliance_review', label: 'Compliance Review' },
    { value: 'aml_check', label: 'AML Check' },
    { value: 'pep_screening', label: 'PEP Screening' },
    { value: 'funds_reserved', label: 'Funds Reserved' },
    { value: 'sent_to_bank', label: 'Sent to Bank' },
    { value: 'in_transit', label: 'In Transit' },
    { value: 'completed', label: 'Completed' },
    { value: 'failed', label: 'Failed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const currencyOptions = [
    { value: '', label: 'All Currencies' },
    { value: 'USD', label: 'USD - US Dollar' },
    { value: 'EUR', label: 'EUR - Euro' },
    { value: 'GBP', label: 'GBP - British Pound' },
    { value: 'CAD', label: 'CAD - Canadian Dollar' },
    { value: 'AUD', label: 'AUD - Australian Dollar' },
    { value: 'JPY', label: 'JPY - Japanese Yen' },
    { value: 'CHF', label: 'CHF - Swiss Franc' }
  ];

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      search: '',
      dateFrom: '',
      dateTo: '',
      status: '',
      recipient: '',
      currency: '',
      amountMin: '',
      amountMax: ''
    };
    setFilters(clearedFilters);
    onClearFilters();
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value !== '');

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Filter Transactions</h3>
        {hasActiveFilters && (
          <Button
            variant="outline"
            onClick={handleClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div className="lg:col-span-2">
          <Input
            label="Search"
            type="search"
            placeholder="Transaction ID, recipient name..."
            value={filters?.search}
            onChange={(e) => handleFilterChange('search', e?.target?.value)}
          />
        </div>

        {/* Status Filter */}
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
        />

        {/* Currency Filter */}
        <Select
          label="Currency"
          options={currencyOptions}
          value={filters?.currency}
          onChange={(value) => handleFilterChange('currency', value)}
        />

        {/* Date From */}
        <Input
          label="Date From"
          type="date"
          value={filters?.dateFrom}
          onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
        />

        {/* Date To */}
        <Input
          label="Date To"
          type="date"
          value={filters?.dateTo}
          onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
        />

        {/* Amount Min */}
        <Input
          label="Min Amount"
          type="number"
          placeholder="0.00"
          value={filters?.amountMin}
          onChange={(e) => handleFilterChange('amountMin', e?.target?.value)}
        />

        {/* Amount Max */}
        <Input
          label="Max Amount"
          type="number"
          placeholder="10,000.00"
          value={filters?.amountMax}
          onChange={(e) => handleFilterChange('amountMax', e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default TransactionFilters;